const locale = window.heroLocale;

var script = document.createElement('script');
script.type = "text/javascript";
script.async = true;

if (locale === 'de-DE' || locale === 'de-AT' || locale === 'de-CH' ) {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=de';
} else if (locale === 'fr-FR') {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=fr';
} else if (locale === 'es-ES') {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=es';
} else if (locale === 'it-IT') {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=it';
} else if (locale === 'nl-NL') {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=nl';
} else if (locale === 'pt-PT') {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=pt';
} else {
    script.src = 'https://www.provenexpert.com/widget/richsnippet.js?u=2RmA34zZlSGB4VKA4HmAlVKB2pQp2LQB&v=3&l=en';
}

window.setTimeout(() => {
    (document.getElementsByTagName('body')[0]).appendChild(script);
},200)
